const { get } = require('./api');
let mockData = {
	"d": [{ "PartNumber": "JR25577", "DisplayValue": "JR25577 (COLLET)", "Url": "/parts/JR25577" }, { "PartNumber": "JR25595", "DisplayValue": "JR25595 (PATCH)", "Url": "/parts/JR25595" }, { "PartNumber": "JR25596", "DisplayValue": "JR25596 (PATCH)", "Url": "/parts/JR25596" }, { "PartNumber": "JR25504", "DisplayValue": "JR25504 (RING)", "Url": "/parts/JR25504" }, { "PartNumber": "JR25508A", "DisplayValue": "JR25508A (DUCT)", "Url": "/parts/JR25508A" }]
}

const autoSuggest = () => {

	const $triggers = document.querySelectorAll('.js-autosuggest');
	$triggers.forEach($el => {
		const isDebug = ($el.getAttribute('data-debug') == 'true') ? true : false;
		const $search = $el.querySelector('input[type=search]');
		const $searchField = $search.closest('.field');
		const $searchControl = $search.closest('.control');
		const $searchButton = $el.querySelector('.search-trigger');
		const $form = $el.querySelector('form');
		const formAction = $form.getAttribute('action');
		const $resultsPane = $el.querySelector('.search-suggestions');
		const values = {};
		let query;

		let searchtimeout;

		// disable Enter key on autosuggest forms
		if ($el.getAttribute('data-no-enter') === "true") {
			$form.addEventListener('keydown', function(event) {
				const e = event || window.event;
				if (e.keyCode === 13) {
					e.preventDefault();
					return;
				}
			});
		}

		$search.addEventListener('input', (ev) => {
			clearTimeout(searchtimeout);
			query = ev.target.value;
			if (query != '') {
				$searchField.classList.add('is-success');
			} else {
				$searchField.classList.remove('is-success');
			}

			searchtimeout = setTimeout(() => {

				// connect with api when searchstring is minimum 1 character(s) and user has stopped typing
				if (query.length >= 1) {
					values.searchString = query;
					if (isDebug) {
						console.log('debug, heres some fake data');
						showResults({ 'response': JSON.stringify(mockData) });
					} else {
						$searchControl.classList.add('is-loading');
						get(`${formAction}?pn=${query}`, showResults, onFail);
					}
				} else {
					$resultsPane.classList.add('is-hidden');
					$searchControl.classList.remove('is-loading');
				}
			}, 300);
		});
		$searchButton.addEventListener('click', (ev) => {
			clearTimeout(searchtimeout);
			if ($searchField.classList.contains('is-success')) $searchField.classList.remove('is-success');
			$resultsPane.querySelector('ul').innerHTML = '';
			$resultsPane.classList.add('is-hidden');
			$resultsPane.querySelector('.no-results').classList.add('is-hidden');
		});

		// populate results container
		const showResults = (data) => {
			$resultsPane.classList.remove('is-hidden');
			$resultsPane.querySelector('.no-results').classList.add('is-hidden');
			$resultsPane.querySelector('ul').innerHTML = '';
			$searchControl.classList.remove('is-loading');
			const results = JSON.parse(data.response).d;

			if (results.length > 0) {
				results.forEach(result => {
					const $item = document.createElement('li');
					$item.classList.add('suggestion');
					const $link = document.createElement('a');
					$link.setAttribute('href', `${result.Url}`);
					$link.innerHTML = result.DisplayValue;
					$item.appendChild($link);

					$resultsPane.querySelector('ul').appendChild($item);
				});
			} else {
				// show 0 results warning
				$resultsPane.querySelector('.no-results').classList.remove('is-hidden');
				$resultsPane.querySelector('.no-results span').innerHTML = query;
			}
		}

		const onFail = (data) => {
			console.error(data);
			$searchControl.classList.remove('is-loading');
		}
	});
};

module.exports = {
	init: autoSuggest
};
